<template>
  <v-container>
    <v-layout justify-center>
      <v-flex>
        <v-card>
          <v-card-text class="text-center">
            <h3>{{$t('error404.title')}}</h3>
          </v-card-text>
          <v-card-text class="text-center">
            {{$t('error404.pageNotFound')}}
          </v-card-text>
          <v-card-actions>
            <v-btn v-on:click="goBack" color="primary">{{ $t('backButton') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import router from '@/router';
  export default {
    name: 'direct-login',
    methods: {
      goBack() {
        router.push({
          'name': 'home'
        });
      }
    }
  };
</script>
